import type { Router } from 'vue-router';
import { useProjectCreateDraftStore } from '@/stores/useProjectCreateDraftStore';

/**
 * 打开「项目创建」页：先分配 draftKey 再跳转，避免 Layout 先以无 draft 开签、
 * 再 replace 补 draft 时出现两个「新项目项目创建」页签。
 */
export function navigateToProjectCreate(router: Router) {
  const draftKey = useProjectCreateDraftStore().createDraft();
  return router.push({ name: 'ProjectCreate', query: { draft: draftKey } });
}
